export default {"src":"/_next/static/media/section8.420a0185.svg","height":453,"width":556,"blurWidth":0,"blurHeight":0};